/*
 * @Descripttion:
 * @Author: zhangtingjiang
 * @Date: 2019-12-25 10:33:34
 */
import Vue from 'vue'

export default new Vue()



// WEBPACK FOOTER //
// ./src/components/events.js